// extracted by mini-css-extract-plugin
export default {"loader":"Gc9eSq6WzpMlXTAuGr7XfPDCFSwrpKh87geDNUjbLTg="};